import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ActivationPage from 'gatsby-theme-carbon/src/templates/ActivationPage';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const InlineNotification = makeShortcode("InlineNotification");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Learning tasks for developers to understand the concepts, technologies and methodologies for cloud native development`}</p>
    </PageDescription>
    <p>{`Credits: This material heavily draws from `}<a parentName="p" {...{
        "href": "https://cloudnative101.dev/"
      }}>{`cloud native bootcamp`}</a></p>
    <p>{`Before you jump straight into Cloud native development using this crafted enablement journey, it’s important you understand the related basic concepts, technologies used and methodologies applied for cloud native development`}</p>
    <p>{`Developer Foundation is broken into three areas: `}</p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Concepts" subTitle="Principles of cloud, cloud native development & deployment" href="developer-foundation#concepts" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1002px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABA//EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABPhmgLnbn/8QAGhABAQACAwAAAAAAAAAAAAAAAgEAAxESIf/aAAgBAQABBQLXVJ3Sylc6/VtEJtuf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFxEBAAMAAAAAAAAAAAAAAAAAAAEhMf/aAAgBAgEBPwGdU//EABsQAAIBBQAAAAAAAAAAAAAAAAAQARESIUGB/9oACAEBAAY/ArdHKqDC/8QAGRABAAMBAQAAAAAAAAAAAAAAAQARMSFB/9oACAEBAAE/IeGWtJQoC/CM6IkD7B7ugl7Wf//aAAwDAQACAAMAAAAQi8//xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAEDAQE/EBcu3//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/EAQ//8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFRQXH/2gAIAQEAAT8QXJjKk5sfsp2ARxbWcy+Kr6pEEsQZhbJteQAosdn/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "sysadmins",
              "title": "sysadmins",
              "src": "/ibm-cloudnative-journey/static/c416dfbbacfaea1aa920491f05c55409/0c625/sysadmins.jpg",
              "srcSet": ["/ibm-cloudnative-journey/static/c416dfbbacfaea1aa920491f05c55409/69549/sysadmins.jpg 288w", "/ibm-cloudnative-journey/static/c416dfbbacfaea1aa920491f05c55409/473e3/sysadmins.jpg 576w", "/ibm-cloudnative-journey/static/c416dfbbacfaea1aa920491f05c55409/0c625/sysadmins.jpg 1002w"],
              "sizes": "(max-width: 1002px) 100vw, 1002px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Technology" subTitle="Basics of Containers, Kubernetes/Openshift" href="developer-foundation#technologies" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAQD/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDBP/aAAwDAQACEAMQAAABxkvklvwBT//EABgQAQADAQAAAAAAAAAAAAAAAAIAETEQ/9oACAEBAAEFAmaNcerJ/8QAFhEBAQEAAAAAAAAAAAAAAAAAAREQ/9oACAEDAQE/AUJc/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFhABAQEAAAAAAAAAAAAAAAAAEAHR/9oACAEBAAY/AsY//8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERITFh/9oACAEBAAE/IbCy+CWuIgr2eNGRT//aAAwDAQACAAMAAAAQQw//xAAXEQEAAwAAAAAAAAAAAAAAAAAAAREh/9oACAEDAQE/ENwin//EABYRAQEBAAAAAAAAAAAAAAAAAAEREP/aAAgBAgEBPxAWzP/EABoQAQEBAQADAAAAAAAAAAAAAAERACFBcZH/2gAIAQEAAT8QtAOqRH5pqA+uuAWaCBWwJM7zy4e//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "code2",
              "title": "code2",
              "src": "/ibm-cloudnative-journey/static/d41e8261a5cf31d7c026b62f70377e00/4edc6/code2.jpg",
              "srcSet": ["/ibm-cloudnative-journey/static/d41e8261a5cf31d7c026b62f70377e00/69549/code2.jpg 288w", "/ibm-cloudnative-journey/static/d41e8261a5cf31d7c026b62f70377e00/473e3/code2.jpg 576w", "/ibm-cloudnative-journey/static/d41e8261a5cf31d7c026b62f70377e00/4edc6/code2.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Methodology" subTitle="IBM Garage Method" href="developer-foundation#method" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABYBAQEBAAAAAAAAAAAAAAAAAAMBBP/aAAwDAQACEAMQAAABRNSrSGRw0//EABkQAAIDAQAAAAAAAAAAAAAAAAABAhEhQf/aAAgBAQABBQJncGiKuTpH/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/AY1//8QAFxEBAQEBAAAAAAAAAAAAAAAAAQASMf/aAAgBAgEBPwHrYW//xAAXEAEAAwAAAAAAAAAAAAAAAAAQABEx/9oACAEBAAY/AmzJ/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERITFB/9oACAEBAAE/Icq8pFhroseEuiLomDo//9oADAMBAAIAAwAAABBvD//EABcRAAMBAAAAAAAAAAAAAAAAAAABIXH/2gAIAQMBAT8QaaTD/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERkfD/2gAIAQIBAT8QYpS3tP/EABoQAQEBAQEBAQAAAAAAAAAAAAERIQBRMYH/2gAIAQEAAT8QYVMMnvj2ilj5HgQrrS5yOHmT860YZ5ywFT6M7//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "code1",
              "title": "code1",
              "src": "/ibm-cloudnative-journey/static/8600626a984bd9e9412dd9fc9b50f517/187aa/code1.jpg",
              "srcSet": ["/ibm-cloudnative-journey/static/8600626a984bd9e9412dd9fc9b50f517/69549/code1.jpg 288w", "/ibm-cloudnative-journey/static/8600626a984bd9e9412dd9fc9b50f517/473e3/code1.jpg 576w", "/ibm-cloudnative-journey/static/8600626a984bd9e9412dd9fc9b50f517/187aa/code1.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <InlineNotification mdxType="InlineNotification">
Developer Foundation uses Katacode service extensively for hands on labs. Katacoda is an interactive learning and training platform for software developers. Each student is given access to a new environment without the need to install all the required component by themselves.
    </InlineNotification>
    <h2>{`Concepts`}</h2>
    <h3>{`Topics Covered`}</h3>
    <Tabs mdxType="Tabs">
      <Tab label="Self Paced" mdxType="Tab">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Topics`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Description`}</th>
              <th parentName="tr" {...{
                "align": "left"
              }}>{`Link`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`What is Cloud Native?`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Cloud Native Overview`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/cloud-native-overview/"
                }}>{`Cloud Native`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Cloud Native App. Dev`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Basics of Cloud Native App. Development`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/cloud-native-app-dev/"
                }}>{`Cloud Native App. Dev`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Continuous Integration`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`CI Overview`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/continuous-integration/"
                }}>{`CI`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Continuous Delivery`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`CD Overview`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/continuous-delivery/"
                }}>{`CD`}</a></td>
            </tr>
          </tbody>
        </table>
      </Tab>
    </Tabs>
    <h2>{`Technologies`}</h2>
    <h3>{`Topics Covered`}</h3>
    <Tabs mdxType="Tabs">
      <Tab label="Self Paced" mdxType="Tab">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Topics`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Description`}</th>
              <th parentName="tr" {...{
                "align": "left"
              }}>{`Link`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Core Concepts`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers Kubernetes Objects and Namespaces.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-core-concepts/"
                }}>{`Core Concepts`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Configuration`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Coveres ConfigMaps, Resource Quotas, Secrets, and Service Accounts.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-configuration/"
                }}>{`Configuration`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Multi-Container Pods`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Use Cases for multi container pods.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-multi-container-pods/"
                }}>{`Multi-Container Pods`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Observability`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers probes and logging for containers.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-observability/"
                }}>{`Observability`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Pod Design`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers Labels, Selectors, Deployments, and Jobs.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-pod-design/"
                }}>{`Pod Design`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Services & Networking`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers Services and Ingresses.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-services-networking/"
                }}>{`Services and Networking`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`State Persistence`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covering Volumes and Persistence Volumes.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-state-persistence/"
                }}>{`State Persistence`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Troubleshooting`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Ways to troubleshoot your kubernetes.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-troubleshooting/"
                }}>{`Troubleshooting`}</a></td>
            </tr>
          </tbody>
        </table>
      </Tab>
    </Tabs>
    <h3>{`Activities`}</h3>
    <Tabs mdxType="Tabs">
      <Tab label="Self Paced" mdxType="Tab">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Topics`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Description`}</th>
              <th parentName="tr" {...{
                "align": "left"
              }}>{`Link`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Pod Creation`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-core-concepts/"
                }}>{`Core Concepts`}</a>{` page.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab1"
                }}>{`Pod Creation`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Pod Configuration`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-configuration/"
                }}>{`Configuration`}</a>{` page.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab2"
                }}>{`Pod Configuration`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Multiple Containers`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-multi-container-pods/"
                }}>{`Multi-Container Pods`}</a>{` page.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab3"
                }}>{`Multiple Containers`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Probes`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-observability/"
                }}>{`Observability`}</a>{` page.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab4"
                }}>{`Probes`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Rolling Updates Lab`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-pod-design/"
                }}>{`Pod Design`}</a>{` page.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab6"
                }}>{`Rolling Updates`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Cron Jobs Lab`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-pod-design#jobs-and-cronjobs"
                }}>{`Pod Design Jobs`}</a>{` section.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab7"
                }}>{`Crons Jobs`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Creating Services`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-services-networking/"
                }}>{`Services`}</a>{` page.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab8"
                }}>{`Setting up Services`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Setting up Persistent Volumes`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-state-persistence/"
                }}>{`State Persistence`}</a>{` page.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab10"
                }}>{`Setting up Persistent Volumes`}</a></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Debugging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Covers the topics in the `}<a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/k8s-troubleshooting/"
                }}>{` Troubleshooting`}</a>{` page.`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/lab5"
                }}>{`Debugging`}</a></td>
            </tr>
          </tbody>
        </table>
      </Tab>
    </Tabs>
    <h3>{`Solutions`}</h3>
    <Tabs mdxType="Tabs">
      <Tab label="Self Paced" mdxType="Tab">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Topics`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Link`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`Solutions`}</td>
              <td parentName="tr" {...{
                "align": null
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/activities/labs/solutions"
                }}>{`Solutions for Exercises`}</a></td>
            </tr>
          </tbody>
        </table>
      </Tab>
    </Tabs>
    <h2>{`Optional Extra Credits`}</h2>
    <h3>{`Kubernetes`}</h3>
    <ActivationPage content="kubernetes" tileColor="bx--article-card--ibm" mdxType="ActivationPage">
    </ActivationPage>
    <h3>{`Deployment Best practices`}</h3>
    <p>{`Use the following links to help you get a deeper understanding of this a good understanding and deep dive in Cloud Native Deployment`}</p>
    <ActivationPage content="cndp" mdxType="ActivationPage">
    </ActivationPage>
    <h2>{`Method`}</h2>
    <h3>{`Topics Covered`}</h3>
    <Tabs mdxType="Tabs">
      <Tab label="Self Paced" mdxType="Tab">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Topics`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Description`}</th>
              <th parentName="tr" {...{
                "align": "left"
              }}>{`Link`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`IBM Garage Method`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Garage Method  Overview`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}><a parentName="td" {...{
                  "href": "/ibm-cloudnative-journey/developer-foundation/garage-development/"
                }}>{`Garage Method`}</a></td>
            </tr>
          </tbody>
        </table>
      </Tab>
    </Tabs>
    <h2>{`Resources`}</h2>
    <ul>
      <li parentName="ul">{`Presentation: `}<a parentName="li" {...{
          "href": "/ibm-cloudnative-journey/slides/03-Kubernetes-Basics.pdf"
        }}>{`Kubernetes Basics`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      